import React from 'react'

export default function UiInnerSearchWr(props) {

    return (

        <div className='sba-search-dropdown-wr' {...props} />

    )
}
